class SimpleAnime {
    constructor() {
      this.items = document.querySelectorAll("[data-anime]");
      this.init();
    }
  
    animateItems() {
      this.items.forEach(item => {
        const delay = Number(item.getAttribute("data-anime"));
        if (!isNaN(delay)) {
          setTimeout(() => {
            item.classList.add("anime");
          }, delay);
        }
      });
    }
  
    handleVisibility() {
      if (document.visibilityState !== undefined) {
        if (document.visibilityState === "visible") {
          this.animateItems();
        }
      } else {
        this.animateItems();
      }
    }
  
    init() {
      this.handleVisibility = this.handleVisibility.bind(this);
      this.handleVisibility();
      document.addEventListener("visibilitychange", this.handleVisibility);
    }
  }
  
  export default SimpleAnime;
  